import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { WorkspaceCapture } from "./WorkspaceCapture";
import { routes } from "./WorkspaceCapture.Parts";

// LOADER

// WRAPPER

// ROUTE
export const WorkspaceCaptureRouteObject: RouteObject = {
  path: routes.base,
  errorElement: <GeneralErrorPage />,
  Component: WorkspaceCapture,
};
